import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=04b58f1c&scoped=true"
var script = {}
import style0 from "./Logo.vue?vue&type=style&index=0&id=04b58f1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b58f1c",
  null
  
)

export default component.exports